<script>
import StudentWritingSubmission from "@/view/pages/classes/StudentWritingSubmission.vue";
import StudentSpeakingSubmission from "@/view/pages/classes/StudentSpeakingSubmission.vue";
import Evaluation from "@/view/pages/classes/Evaluation.vue";
import {
  GET_EXAM_ANSWER_MIDTERM_TEST,
  GET_MIDTERM_TEST_RESULT,
} from "@/core/services/store/course/classes.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {SPEAKING, WRITING, LISTENING, READING} from "@/common/courseTemplate";
import ReadingListeningResult from "@/view/pages/classes/components/ReadingListeningResult.vue";
import {getEvaluationTemplate} from '@/common/markingTemplate'

export default {
  name: "ViewMidtermTestResult",
  components: {ReadingListeningResult, Evaluation, StudentSpeakingSubmission, StudentWritingSubmission},
  data() {
    return {
      classLevel: 1,
      markingData: [],
      studentName: this.$route.query.name,
      markingDataIndex: 0,
      SPEAKING,
      WRITING,
      evaluationFollowClass: null,
      typeExam: LISTENING,
      dataListeningAndReading: {}
    }
  },
  computed: {
    isEntrance() {
      const { isEntrance } = this.$route.query;
      return isEntrance === true || isEntrance === 'true';
    },
    isListenAndRead() {
      return this.typeExam === LISTENING || this.typeExam === READING
    },
    currenMarkingData() {
      if (this.markingData.length === 0) {
        return null
      }
      return this.markingData[this.markingDataIndex]
    },
    dataListenAndRead() {
      return this.typeExam === LISTENING ? this.dataListeningAndReading?.listening : this.dataListeningAndReading?.reading
    }
  },
  methods: {
    backQuestion() {
      if (this.typeExam === SPEAKING && this.markingDataIndex === 0) {
        this.typeExam = READING
      } else {
        this.markingDataIndex--
        this.typeExam = SPEAKING
      }
    },
    nextQuestion() {
      if (this.typeExam === SPEAKING || (this.typeExam === WRITING && this.markingDataIndex < this.markingData.length - 1)) {
        this.markingDataIndex++
        this.typeExam = WRITING
      }
    },
    async getExamAnswerMidtermTest() {
      try {
        const payload = {marking_retake_id: this.$route.params.id}
        const data = await this.$store.dispatch(GET_EXAM_ANSWER_MIDTERM_TEST, payload)
        const results = await this.$store.dispatch(GET_MIDTERM_TEST_RESULT, {marking_exam_retake_id: this.$route.params.id})
        const speakingResult = results?.data?.speakings
        const writingsResult = results?.data?.writings
        this.dataListeningAndReading = results?.data
        const speakingEvaluation = JSON.parse(JSON.stringify(this.getTemplate(data?.data?.rubric?.key, this.SPEAKING)))
        const isSingleWriting = data?.data?.writings?.length === 1
        const writingPart = data?.data?.writings?.map((writing, index) => ({
          testType: this.WRITING,
          question: writing?.question,
          image: writing?.image,
          userAnswer: writing?.answer,
          evaluation: this.mapTeacherMarksToTemplate(JSON.parse(JSON.stringify(this.getTemplate(data?.data?.rubric?.key, this.WRITING, index, isSingleWriting))), writingsResult[index]),
          cheating: writingsResult[index]?.cheating?.type == null
              ?
              {isCheating: false, PlagiarismRate: null, comment: ''}
              :
              {
                isCheating: true,
                PlagiarismRate: writingsResult[index]?.cheating?.type,
                comment: writingsResult[index]?.cheating?.description
            },
          didStudentDo: { value: writing?.has_submitted ?? true },
          gradingType: writing?.writing_grading_type??'admin'
        }));
        const speakingPart = {
          testType: this.SPEAKING,
          questionsAndAnswers: data?.data?.speakings?.map(speaking => ({
            id: speaking?.id,
            content: speaking?.content,
            answer: speaking?.answer
          })),
          evaluation: this.mapTeacherMarksToTemplate(speakingEvaluation, speakingResult),
          cheating: speakingResult?.cheating?.type == null
              ?
              {isCheating: false, PlagiarismRate: null, comment: ''}
              :
              {
                isCheating: true,
                PlagiarismRate: speakingResult?.cheating?.type,
                comment: speakingResult?.cheating?.description
              },
          didStudentDo: { value: speakingResult?.has_submitted ?? true },
          gradingType: 'admin'
        };
        this.markingData = [speakingPart, ...writingPart]
        this.evaluationFollowClass = {...speakingEvaluation}
      } catch (e) {
        console.log(e)
      }
    },
    getTemplate(rubricKey, examType, index = 0, isSingleWriting = false) {
      return getEvaluationTemplate(rubricKey, examType, index, isSingleWriting)
    },
    mapTeacherMarksToTemplate(template, result) {
      const marks = result.teacher_marks || [];
      template.items.forEach((skill) => {
        skill.items.forEach((subItem) => {
          const mark = marks.find(
              (m) => m.key === subItem.key && m.key_parent === skill.key
          );
          if (mark) {
            subItem.comment_auto = mark.comment_auto;
            subItem.criterion_score = mark.score;
            skill.comment_detail = mark.comment_detail;
            subItem.e_comment_auto = mark.e_comment_auto;
          }
        });
      });

      return template;
    },
    handleChangeSkill(value) {
      this.typeExam = value
    }
  },

  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.isEntrance ? "Chấm bài thi đầu khóa" : "Chấm bài thi giữa khóa"},
      {title: this.isEntrance ? "Xem bài thi đầu khóa" : "Xem bài thi giữa khóa"}
    ]);
    await this.getExamAnswerMidtermTest()
  }
}
</script>

<template>
  <ReadingListeningResult
      v-if="isListenAndRead"
      @changeSkill="handleChangeSkill"
      :question-and-answer-info="dataListenAndRead"
  />
  <div v-else style="background-color: white;   border-radius: 8px;" class="p-5">
    <header class="d-flex justify-content-between align-items-center pb-4" style="border-bottom: 1px grey solid;">
      <p class="mb-0" style="font-size: 16px; font-weight: bold">{{ studentName }}</p>
      <div class="d-flex align-items-center">
        <div v-for="(item,indexItem) in markingData" :key="indexItem" class="step-item">
          <div class="step-circle"
               :class="indexItem=== markingDataIndex?'step-current':'step-completed'">{{ indexItem + 1 }}
          </div>
          <span class="marking-badge" :class="item.isAI ? 'badge-ai' : 'badge-admin'">
            {{ item.gradingType !=='admin' ? 'AI hỗ trợ chấm' : 'Admin chấm' }}
          </span>
        </div>
      </div>
      <div class="manager-step-question" style="width: 300px; display: flex;justify-content: right">
        <button v-if="markingDataIndex || typeExam === SPEAKING" type="button" class="btn btn-secondary"
                @click="backQuestion()">Quay lại
        </button>
        <button v-if="typeExam !== WRITING || (typeExam === WRITING && markingData.length - 1 !==  markingDataIndex)"
                type="button" class="btn btn-success"
                @click="nextQuestion()">Kĩ năng tiếp
        </button>
      </div>
    </header>
    <section class="row py-5">
      <div class="col-5">
        <StudentWritingSubmission v-if="currenMarkingData?.testType === WRITING"
                                  :currenMarkingData="currenMarkingData"></StudentWritingSubmission>
        <StudentSpeakingSubmission v-if="currenMarkingData?.testType === SPEAKING"
                                   :currenMarkingData="currenMarkingData"></StudentSpeakingSubmission>
      </div>
      <div class="col-7">
        <evaluation :evaluationData="currenMarkingData?.evaluation"
                    :cheating="currenMarkingData?.cheating" :didStudentDo="currenMarkingData?.didStudentDo"
                    :isAI="currenMarkingData?.isAI" :isView="true"></evaluation>
      </div>
    </section>

  </div>
</template>

<style scoped>
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
}

.step-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  color: white;
}

.marking-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-top: 5px;
  font-weight: 500;
  white-space: nowrap;
}

.badge-ai {
  background-color: #52c41a;
  color: white;
}

.badge-admin {
  background-color: #b37feb;
  color: white;
}

.step-completed {
  background-color: #dcdcdc; /* xanh lá */
  color: black;
}

.step-current {
  background-color: #0275d8; /* xanh dương */
}

.step-container {
  border: 2px solid #0d6efd;
  padding: 5px 10px;
  display: inline-flex;
  border-radius: 4px;
}

.manager-step-question > * + * {
  margin-left: 20px; /* tương đương space-x-4 */
}

</style>
